import { Input, ColorPicker } from "antd";
import {
  isValidHexWithoutHash,
  removeInvalidHexCharacters,
  convert3To6Hex,
} from "../../utils/parsing";
import { useEffect, useState } from "react";
import "./RectColorPicker.scss";

const RectColorPicker = ({
  color,
  colorKey,
  setColorValue,
  style,
}: {
  color: string;
  colorKey: string;
  setColorValue: (key: string, color: string) => void;
  style?: React.CSSProperties;
}) => {
  const removeHash = (hex: string) => hex.replace("#", "");
  const [inputColor, setInputColor] = useState(removeHash(color));
  // prop color update is too slow, so we use a local state to store the color
  const [compColor, setCompColor] = useState(color);

  useEffect(() => {
    setInputColor(removeHash(color));
    setCompColor(color);
  }, [color]);

  const handleChange = (newColor: string) => {
    const cleanedColor = removeInvalidHexCharacters(newColor);
    setInputColor(cleanedColor);

    if (isValidHexWithoutHash(cleanedColor)) {
      const convertedColor = convert3To6Hex(cleanedColor);
      setColorValue(colorKey, "#" + convertedColor);
      setCompColor(convertedColor);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const cleanedColor = removeInvalidHexCharacters(e.target.value);
    if (!isValidHexWithoutHash(cleanedColor)) {
      setInputColor(removeHash(color));
    }
  };
  const handleColorChange = (c: string) => {
    setCompColor(c);
    setColorValue(colorKey, c);
  };

  return (
    <div className="color-item" style={style}>
      <div className="color-picker-wrapper">
        <ColorPicker
          defaultValue="#1677ff"
          value={compColor}
          onChange={(c) => handleColorChange(c.toHexString())}
          disabledAlpha
          destroyTooltipOnHide
        />
      </div>

      <div className="color-item-input">
        <Input
          maxLength={7}
          value={removeHash(inputColor)}
          prefix="#"
          onChange={(e) => {
            handleChange(removeHash(e.target.value));
          }}
          onBlur={(e) => {
            handleBlur(e);
          }}
        />
      </div>
    </div>
  );
};

export default RectColorPicker;
